import {
  Control,
  Controller,
  FieldErrors,
  UseFormGetValues,
  UseFormSetValue,
  useWatch,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { AllEnums } from '~/data/enums';
import {
  getCountryByLegalEntity,
  useAllLegalEntities,
} from '~/data/legalEntity';
import { useSxStyles } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/components/ScheduleEmployment/components/FormComponent/components/Common/useStyles';
import { Form } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';
import { LegacyAutocompleteField } from '~/legacy-components/LegacyForms';
import { filterActiveEnumsByCountryAndOrgUnits } from '~/utils/helper';

type Props = {
  control: Control<Form>;
  errors: FieldErrors<Form>;
  getValues: UseFormGetValues<Form>;
  allEnums: AllEnums;
  index: number;
  setValue: UseFormSetValue<Form>;
};

export const InternalPositionComponent = ({
  control,
  getValues,
  allEnums,
  errors,
  index,
  setValue,
}: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const requiredText = t('fieldIsRequired');
  // @ts-ignore
  useWatch({
    control,
    name: `schedule.${index}.empPosition.fEmpLegalEntity`,
  });

  useWatch({
    control,
    name: `schedule.${index}.empPosition.fInternalPositionUnit`,
  });

  const fEmpLegalEntityValue = getValues(
    `schedule.${index}.empPosition.fEmpLegalEntity`,
  );

  const fEmpOrgUnitValue = getValues(
    `schedule.${index}.empPosition.fInternalPositionUnit`,
  );

  const { legalEntities } = useAllLegalEntities();

  const filteredOptions = filterActiveEnumsByCountryAndOrgUnits(
    allEnums['EMPLOYEE_POSITION'],
    getCountryByLegalEntity(+fEmpLegalEntityValue, legalEntities),
    fEmpOrgUnitValue,
  );

  return (
    <Controller
      control={control}
      name={`schedule.${index}.empPosition.fInternalPositionPosition`}
      rules={{ required: requiredText }}
      render={({ field: { onChange, value } }) => (
        <LegacyAutocompleteField
          required
          sx={sxStyles.selectStyle}
          placeholder={t('laSelectFirstLegEnt')}
          disabled={fEmpLegalEntityValue === ''}
          options={filteredOptions}
          getOptionLabel={(c) => c?.name || ''}
          onChange={(e, value) => {
            onChange(value?.code || '');
          }}
          value={filteredOptions.find((ep) => ep?.code === value) || null}
          label={t('laPosition')}
          fieldError={
            errors.schedule?.[index]?.empPosition?.fInternalPositionPosition
          }
        />
      )}
    />
  );
};
